<button
  *ngIf="(holidaySingleFamily$ | async | ready) || (holidayMultiFamily$ | async | ready)"
  gtm="onOpen"
  gtmAction="Holiday program dialog"
  gtmCategory="statusPanel"
  [disabled]="isRemoteDiagnostic"
  (click)="openDatepickerDialog()"
  class="flex flex-row justify-start items-center"
  mat-menu-item
>
  <ng-container *ngIf="!displayText">
    {{ '+INSTALLATIONS.INSTALLATION.HOLIDAY_MODE.BUTTON' | translate }}
  </ng-container>
  <ng-container *ngIf="displayText">
    {{ displayText }}
  </ng-container>
</button>
